export default __webpack_public_path__ + "static/media/logo_tomodachi.a26562f5.svg";